<div class="container-fluid">

  <header class="row mt-5 ms-3 me-3">
    <div class="col-12 col-md-12 col-lg-4 col-xl-2 col-xxl-1">
      <img src="../../../../assets/images/logo-blue@3x.png" style="width: 125px;">
    </div>
    <div class="col-12 col-md-12 col-lg-8 col-xl-10 col-xxl-11 step-container">
      <ul class="step step-md step-inline">
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">1</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre compte</h4>
            </div>
          </div>
        </li>
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">2</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre cabinet</h4>
            </div>
          </div>
        </li>

        <li class="step-item active">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-primary">3</span>
            <div class="step-content">
              <h4 class="step-title">Choisissez votre abonnement</h4>
            </div>
          </div>
        </li>
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">4</span>
            <div class="step-content">
              <h4 class="step-title">Bienvenue dans Optitax!</h4>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </header>

  <div class="container">

    <div class="row mt-5">
      <h1 class="display-5">Forfaits Mensuels Optitax <span class="badge text-bg-success">Inclus les calculs fiscaux avancés</span>
    </h1>

    <div class="col-12 col-lg-8">
      <div class="row">
        <div class="col-12 col-lg-6">
          <label id="license_individual">
            <input [formControl]="this.getLicenseTypeFormControl()" class="card-input-element" type="radio"
              value="INDIVIDUAL">
            <div class="card card-input mb-3">
              <div class="text-center mb-4 mt-4">
                <h2 class="mt-2 mb-4 display-1">89$
                  <small>/mois</small>
                </h2>


                <h3 class="mt-3 h2">1 utilisateur</h3>
                <p class="card-text text-secondary">Pour les comptables indépendants</p>
              </div>

              <div class="card-body">
                <!--                            <h6 class="text-uppercase text-center text-muted my-4">-->
                <!--                                1 utilisateur-->
              <!--                            </h6>-->

              <!--                            &lt;!&ndash; Price &ndash;&gt;-->
              <!--                            <div class="row g-0 align-items-center justify-content-center">-->
              <!--                                <div class="col-auto">-->
              <!--                                    <div class="h2 mb-0">89$</div>-->
            <!--                                </div>-->
          <!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->

          <!--                            &lt;!&ndash; Period &ndash;&gt;-->
          <!--                            <div class="h6 text-uppercase text-center text-muted mb-5">-->
          <!--                                / mois-->
        <!--                            </div>-->

        <ul class="list-unstyled ms-4">

          <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
          style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
          1 utilisateur
        </li>
        <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
        style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
        Accès à tous les calculs fiscaux avancés
      </li>
      <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
      style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
      Accès au portail client
    </li>

    <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
    style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
    Nombre illimité de clients
  </li>
  <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
  style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
  Nombre illimité de questionnaires
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès aux questionnaires de récolte d'information client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Support par clavardage
</li>

</ul>

<div class="d-flex align-items-center justify-content-center mt-5">
  <span> <i class="fas fa-check-circle"></i> </span>
</div>
</div>

</div>
</label>
</div>

<div class="col-12 col-lg-6">
  <label id="license_team">
    <input [formControl]="this.getLicenseTypeFormControl()" class="card-input-element" type="radio"
      value="TEAM">
    <div class="card card-input mb-3">
      <div class="text-center mb-4 mt-4">
        <h2 class="mt-2 mb-4 display-1">199$
          <small>/mois</small>
        </h2>


        <h3 class="mt-3 h2">25 utilisateurs</h3>
        <p class="card-text text-secondary">Pour les cabinets comptables</p>
      </div>

      <div class="card-body">
        <!--                            <h6 class="text-uppercase text-center text-muted my-4">-->
        <!--                                1 utilisateur-->
      <!--                            </h6>-->

      <!--                            &lt;!&ndash; Price &ndash;&gt;-->
      <!--                            <div class="row g-0 align-items-center justify-content-center">-->
      <!--                                <div class="col-auto">-->
      <!--                                    <div class="h2 mb-0">89$</div>-->
    <!--                                </div>-->
  <!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->

  <!--                            &lt;!&ndash; Period &ndash;&gt;-->
  <!--                            <div class="h6 text-uppercase text-center text-muted mb-5">-->
  <!--                                / mois-->
<!--                            </div>-->

<ul class="list-unstyled ms-4">

  <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
  style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
  25 utilisateurs
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès à tous les calculs fiscaux avancés
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès au portail client
</li>

<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Nombre illimité de clients
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Nombre illimité de questionnaires
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès aux questionnaires de récolte d'information client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Support par clavardage
</li>

</ul>

<div class="d-flex align-items-center justify-content-center mt-5">
  <span> <i class="fas fa-check-circle"></i> </span>
</div>
</div>

</div>
</label>
</div>

<div class="col-12">
  <h1 class="display-5 mt-3">Forfait Annuel Questionnaire + Portail Client <br><small>(Sans les calculs
  fiscaux avancés)</small></h1>
  <label class="d-block" id="license_questionnaire">
    <input [formControl]="this.getLicenseTypeFormControl()" class="card-input-element" type="radio"
      value="QUESTIONNAIRE">
    <div class="card card-input mb-3">
      <div class="text-center mb-4 mt-4">
        <h2 class="mt-2 mb-4 display-1"><s class="text-danger">499$</s> 99$
        <small>/année</small>
      </h2>


      <h3 class="mt-3 h2">Questionnaires de prise d'information fiscale</h3>
      <p class="card-text text-secondary">Inclus un nombre illimité de questionnaires et clients</p>
    </div>

    <div class="card-body">
      <!--                            <h6 class="text-uppercase text-center text-muted my-4">-->
      <!--                                1 utilisateur-->
    <!--                            </h6>-->

    <!--                            &lt;!&ndash; Price &ndash;&gt;-->
    <!--                            <div class="row g-0 align-items-center justify-content-center">-->
    <!--                                <div class="col-auto">-->
    <!--                                    <div class="h2 mb-0">89$</div>-->
  <!--                                </div>-->
<!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->

<!--                            &lt;!&ndash; Period &ndash;&gt;-->
<!--                            <div class="h6 text-uppercase text-center text-muted mb-5">-->
<!--                                / mois-->
<!--                            </div>-->

<ul class="list-unstyled ms-4">
  <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
  style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
  Nombre illimités de clients
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Nombre illimités de questionnaires
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès au portail client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès aux questionnaires de récolte d'information client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Support par clavardage
</li>

</ul>

<div class="d-flex align-items-center justify-content-center mt-5">
  <span> <i class="fas fa-check-circle"></i> </span>
</div>
</div>

</div>
</label>
</div>
</div>
</div>

<div class="col-12 col-lg-4 bg-primary-soft p-5 rounded">
  <h4>Résumé de l'abonnement</h4>
  <ul class="list-group list-group-flush">
    <li class="list-group-item d-flex align-items-center justify-content-between px-0 pb-5">
      <div><h5>Forfait @if (this.billingCycle === 'MONTHLY') {
        <span>mensuel</span>
        }@if (this.billingCycle === 'YEARLY') {
        <span
        >annuel</span>
      }</h5>
      @if (this.getLicenseTypeFormControl().value === 'TEAM') {
        <span>25 utilisateurs</span>
      }
      @if (this.getLicenseTypeFormControl().value === 'INDIVIDUAL') {
        <span>1 utilisateur</span>
      }
      @if (this.getLicenseTypeFormControl().value === 'QUESTIONNAIRE') {
        <span>Questionnaire + Portail utilisateur (sans les calculs)</span>
      }
    </div>
    <div>{{ subtotal | number:'1.2':'fr-CA' }} $ <br><small
    class="text-gray-700">(taxes en sus)</small></div>
  </li>
</ul>
<br>
  <h4 class="mb-4">Carte de crédit</h4>

  <div id="payment-element">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <!-- the payment element will be mounted here -->
  </div>

  @if (isFreeTrialAllowed) {
    <p class="mt-3">Votre carte de crédit sera débité le
      <strong>{{ freeTrialEnds }}</strong> à moins que
      vous
    annuliez avant.</p>
  }

  @if (isFreeTrialAllowed) {
    <div class="form-check mt-4">
      <input [formControl]="this.freeTrialWithoutCreditCard" class="form-check-input"
        id="free-trial-without-credit-card"
        type="checkbox">
      <label class="form-check-label" for="free-trial-without-credit-card">Essai gratuit sans carte de
      crédit</label>
    </div>
  }

  <div id="error-message"></div>

  <p class="mt-4">En vous abonnant, vous acceptez les <a href="https://optitax.ca/conditions-utilisation">conditions
  d'utilisation</a> d'Optitax.</p>

  <div class="d-grid gap-2">
    @if (isFreeTrialAllowed === true) {
      <button (click)="submit()" class="btn btn-primary"
        id="start-free-trial-btn"
        type="button">Démarrer la période d'essai gratuite
      </button>
    }
    @if (isFreeTrialAllowed === false) {
      <button (click)="submit()" class="btn btn-primary" id="finalize-btn"
        type="button">S'abonner maintenant
      </button>
    }
  </div>
</div>

</div>


</div>
</div>

